import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { DataRecordHelper } from "./data-record.helper";

let DataRecordMessageComponent = {
    selector: "vcDataRecordMessage",
    templateUrl:
        "/angular/components/data-record/data-record-message.component.html",
    bindings: {
        update: "=",
        existingCampaign: "=",
    },
    controller: class DataRecordMessageController {
        // * bindings for typescript compiler *
        public update: any;
        public existingCampaign: any;
        // ************************************

        private dataRecordHelper: DataRecordHelper;
        public dialog: DialogUtils;

        constructor(
            DataRecordHelper: DataRecordHelper,
            DialogUtils: DialogUtils
        ) {
            this.dataRecordHelper = DataRecordHelper;
            this.dialog = DialogUtils;
        }

        openDataRecord(): void {
            this.dataRecordHelper.openDataRecord(false, !this.update);
        }

        close(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dataRecord")
    .component(DataRecordMessageComponent.selector, DataRecordMessageComponent);
